export const CLOCK_ICON = "/icons/interface-icons/shared/icon-3d-clock-up.png";
